app.controller('CIFBenef-CTRL', 
    function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter) {

        $scope.PhoneCode = '+62';
        //$scope.CIFInvestor = {}
        $scope.bankpribadi = '';

        $scope.filenameKKBenef = "";
        $scope.fileKKBenef = "";
        $scope.fileKKBenefext = "";
        $scope.kkbenefFile = "";
        $scope.allowedExt = ['.jpg', '.jpeg', '.bmp', '.png'];

        let tmpdate = new Date();
        tmpdate.setFullYear(tmpdate.getFullYear() - 17);
        $scope.maxDate = tmpdate.toISOString().slice(0, 10);

        $scope.listpekerjaan_BCA = {};
        $scope.listjabatan_BCA = {};
        $scope.listusaha_BCA = {};

        $scope.CIFInvestor = {
            CIFInvestorBeneficiaryOwnerOccupation: ''
        }

        $scope.OPBBCABO = {
            occupation: '',
            occupationText: '',
            position: '',
            positionText: '',
            business: '',
            businessText: ''
        }

        $scope.IDCardCitySelectedBO = '';

        $scope.clickRemoveKKBenef = function (file, event, key) {
            event.preventDefault();
            $scope.fileKKBenef = "";
            $scope.filenameKKBenef = "";
            $scope.fileKKBenefext = "x";
            $scope.kkbenefFile.splice(key, 1);
            $scope.kkbenefFile = [];

            console.log('t', $scope.kkbenefFile)
            return null;
        };

        $scope.selectKKBenef = function (files) {

            $scope.kkbenefFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {

                if (allowed)
                    $scope.fileKKBenef = btoa(e.target.result.toString());
            };

            reader.readAsBinaryString(files[0]);
            $scope.fileKKBenefext = files[0].name.substr(files[0].name.lastIndexOf('.'));
            if ($scope.allowedExt.indexOf($scope.fileKKBenefext.toLowerCase()) < 0) {

                allowed = false;
                $scope.fileKKBenefext = '';
                $scope.kkbenefFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            } else {

                $scope.filenameKKBenef = files[0].name;
            }
        };

        $scope.chkSeumurHidupBO = true;
        $scope.DisabledSeumurHidupBO = true;
        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerIDCardExpiryDate = new Date(9998, 11, 31);

        $scope.selectedFundSourceBO = [];
        $scope.BenefCountrySelected = [];


        $scope.mustSelectBO = function (event, field) {

            if (event.keyCode == 27) {

                let returnValue = true;
                switch (field) {
                    case 'IDCardBO': $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity = ''; returnValue = false;
                        break;
                    case 'CompanyBO': $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = ''; returnValue = false;
                        break;
                    default:
                        break;
                }
                return returnValue;
            }
            return true;
        }

        $scope.selectIDCardCityBO = function (item, model, label, event) {
            $scope.ListKecamatanBO = '';
            $scope.ListKelurahanBO = '';

            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity = item.CIFProvinceCityNID;

                $http({
                    method: 'GET',
                    url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                    cache: true,
                }).then(function (data) {
                    $scope.ListKecamatanBO = data.data.d;
                    $scope.kecamatanChangeBO();
                }, function (error) { });

            }

        };

        $scope.occupationChange_BCA = function () {

            if ($scope.OPBBCABO.occupation) {

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCABO.occupation.key,
                }).then(function (data) {


                    $scope.listjabatan_BCA = data.data.d;

                    if ($scope.listjabatan_BCA.length) {
                        $scope.OPBBCABO.position = $scope.listjabatan_BCA[0];

                        $scope.positionChange_BCA();
                    }
                }, function (error) { });
            }
        };

        $scope.positionChange_BCA = function () {
            $http({
                method: 'GET',
                url: '/service/client.svc/GetBidangUsaha?Jabatan=' + $scope.OPBBCABO.position.key + '&Pekerjaan=' + $scope.OPBBCABO.occupation.key,
            }).then(function (data) {

                $scope.listusaha_BCA = data.data.d;

                if ($scope.listusaha_BCA.length) {

                    $scope.OPBBCABO.businessText = '';
                    $scope.OPBBCABO.business = $scope.listusaha_BCA[0];
                }
            }, function (error) { });
        };


        $scope.kecamatanChangeBO = function () {

            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan)
                $scope.ListKelurahanBO = $filter('filter')($scope.ListKecamatanBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan }, true);
        }

        $scope.kelurahanChangeBO = function () {

            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKelurahan) {

                let temp = $filter('filter')($scope.ListKecamatanBO, { Kelurahan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKelurahan }, true);
                if (temp)
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerPostalCode = temp[0].PostalCode;

            }
        }


        $scope.selectIDCardCityBenefOther = function (item, model, label, event) {
            $scope.ListKecamatanDomicileBO = '';
            $scope.ListKelurahanDomicileBO = '';

            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOtherCity = item.CIFProvinceCityNID;

                $http({
                    method: 'GET',
                    url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                    cache: true,
                }).then(function (data) {
                    $scope.ListKecamatanDomicileBO = data.data.d;
                    $scope.kecamatanDomicileBenefChange();
                }, function (error) { });

            }

        };

        $scope.selectCompanyCityBO = function (item, model, label, event) {
            $scope.ListKecamatanCompanyBO = '';
            $scope.ListKelurahanCompanyBO = '';

            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = item.CIFProvinceCityNID;
                $http({
                    method: 'GET',
                    url: 'service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                    cache: true,
                }).then(function (data) {
                    $scope.ListKecamatanCompanyBO = data.data.d;
                    $scope.kecamatanChangeCompanyCityBO();
                }, function (error) { });
            }

        };

        $scope.selectNationalityBO = function (item, model, label, event) {
            if (item.CIFCountryNID) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCountry = item.CIFCountryNID;
                $scope.BenefCountrySelected = item;
            }

        };


        $scope.toggleFundSourceBOItem = function (fundsource) {
            let indexCIFLookupInteger = $scope.selectedFundSourceBO.indexOf(fundsource.CIFLookupInteger);

            if (indexCIFLookupInteger > -1)
                $scope.selectedFundSourceBO.splice(indexCIFLookupInteger, 1);
            else
                $scope.selectedFundSourceBO.push(fundsource.CIFLookupInteger);

            if ($scope.selectedFundSourceBO.indexOf(1) < 0)
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSourceText = '';

        }

        $scope.openCamera = function (tipe) {
            let message = tipe;
            let url = 'ModalCamera.html';
            let ctrl = 'CameraController';


            //if ($scope.device.isMobile()) {
            //    //url = 'ModalBrowse.html';
            //    //ctrl = 'BrowseController';
            //    //$scope.append = 'data:image/png;base64,';
            //}

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: url,
                controller: ctrl,
                size: 'md',
                resolve: {
                    items: function () {
                        return message;
                    }
                }
            });
            modalInstance.result.then(function (resolvedResponse) {
                if (resolvedResponse) {
                    if (tipe == "KKBenef")
                        $scope.kkbenefPhoto = resolvedResponse;
                    else
                        $scope.ttdPhoto = resolvedResponse;

                }
            }, function () { });
        };

        $scope.remove = function (tipe) {
            if (tipe == "KKBenef")
                $scope.kkbenefPhoto = '';
        };

        $scope.prepareData = function () {

            if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation = $scope.OPBBCABO.occupation.key;

                if ($scope.OPBBCABO.occupation.key == '2' || $scope.OPBBCABO.occupation.key == '3' || $scope.OPBBCABO.occupation.key == '18') {
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerPosition = $scope.OPBBCABO.positionText;
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNatureOfBusiness = $scope.OPBBCABO.businessText;
                }
                else {
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerPosition = $scope.OPBBCABO.position.value;
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNatureOfBusiness = $scope.OPBBCABO.business.value;
                }
            }

            if ($scope.spouseMandatory) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = 2;
                //$scope.CIFInvestor.SpouseCompanyCity = Number($scope.SpouseCompanyCitySelected);
            } else {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwner = 1;
            }


            if ($scope.selectedFundSourceBO) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource = '';
                for (var i = 0; i < $scope.selectedFundSourceBO.length; i++) {
                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource.length > 0)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource += ',';
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource += $scope.selectedFundSourceBO[i];

                }
            }
        };



        var allPromise = $q.all([

            
                $http({
                    method: 'GET',
                    url: 'service/client.svc/GetCIFCountry',
                    cache: true,
                }).then(function (data) {
                    $scope.ListNationality = data.data.d;
                }, function (error) { }),

                 $http({
                     method: 'GET',
                     url: 'service/client.svc/GetCIFCountryAll',
                     cache: true,
                 }).then(function (data) {
                     $scope.ListCountry = data.data.d;
                 }, function (error) { }),

                 $http({
                     method: 'GET',
                     url: 'service/client.svc/GetCIFProvinceCity',
                     cache: true,
                 }).then(function (data) {
                     $scope.ListProvinceCity = data.data.d;
                 }, function (error) { }),

                 $http({
                     method: 'GET',
                     url: '/service/client.svc/GetCIFPekerjaan',
                     cache: true,
                 }).then(function (data) {
                     $scope.listpekerjaan_BCA = data.data.d;
                 }, function (error) { }),

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetJabatan',
                    cache: true,
                }).then(function (data) {
                    $scope.listposition_BCA = data.data.d;
                }, function (error) { }),

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetBidangUsaha',
                    cache: true,
                }).then(function (data) {
                    $scope.listnature_BCA = data.data.d;
                }, function (error) { }),

                 $http({
                     method: 'GET',
                     url: 'service/client.svc/GetCIFLookup',
                     cache: true,
                 }).then(function (data) {

                if (data.status == 200) {

                    $scope.ListLookup = data.data.d;

                    if ($scope.ListLookup) {
                        $scope.ListMaritalBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'MaritalStatus' }, true);
                        $scope.ListEducationBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Educational' }, true);
                        $scope.ListAssetsValue = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                        $scope.ListOccupationBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Occupation' }, true);
                        $scope.ListFundSourceBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'FundSource' }, true);
                        $scope.ListInvestmentBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'InvestmentObjectives' }, true);
                        $scope.ListIncomePerAnnumBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                    }
                }
            }),

        ]);

        allPromise.then(function () {

            
            $http({
                method: 'GET',
                url: 'service/client.svc/getCIF',
                cache: true,
            }).then(function (data) {
                if (data.status == 200) {

                    if (data.data.d != null) {

                        var obj = data.data.d;
                        $scope.CIFInvestor = data.data.d;
                        $scope.CIFInvestor.Stage = 2;
                        $scope.filenameKKBenef = $scope.CIFInvestor.KKBenefFile;

                        if ($scope.filenameKKBenef) {

                            if (!$scope.filenameKKBenef.endsWith(".pdf")) {
                                $http({
                                    method: 'GET',
                                    url: 'FileKYC/' + $scope.filenameKKBenef,
                                    responseType: 'blob',

                                }).then(function (response) {
                                    $scope.kkbenefFile = [];
                                    $scope.kkbenefFile.push(response.data);
                                }, function (response) {
                                    $scope.saveErrors = true;
                                    $scope.errorMessages = {
                                        text: 'File tidak ketemu atau terhapus dari server!!!',
                                    };
                                    $timeout(function () {
                                        $scope.saveErrors = false;
                                    }, 3000);
                                });
                            }
                        };

                        //var obj = data.data.d;
                        //$scope.CIFInvestor = data.data.d;
                        //$scope.CIFInvestor.Stage = 2;
                        //$scope.filenameKKBenef = $scope.CIFInvestor.KKBenefFile;

                        //if ($scope.filenameKKBenef) {
                        //    $http({
                        //        method: 'GET',
                        //        url: 'FileKYC/' + $scope.filenameKKBenef + "?timestamp=" + Date.now(),
                        //        responseType: 'blob',

                        //    }).then(function (response) {
                        //        let reader = new FileReader();
                        //        reader.readAsDataURL(response.data);
                        //        reader.onloadend = function () {
                        //            $scope.kkbenefPhoto = reader.result;
                        //        }
                        //    }, function (response) {
                        //        $scope.saveErrors = true;
                        //        $scope.errorMessages = {
                        //            text: 'File tidak ketemu atau terhapus dari server!!!',
                        //        };
                        //        $timeout(function () {
                        //            $scope.saveErrors = false;
                        //        }, 3000);
                        //    });
                        //};

                        if ($scope.CIFInvestor.QuestionRDN == 1) {

                            if ($scope.CIFInvestor.Occupation == 1 || $scope.CIFInvestor.Occupation == 2) {
                                $scope.spouseMandatory = true;
                            }

                            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation && $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation > 0) {

                                $scope.OPBBCABO.occupation = $filter('filter')($scope.listpekerjaan_BCA, { key: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation }, true)[0];


                                $http({
                                    method: 'GET',
                                    url: '/service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCABO.occupation.key,
                                }).then(function (data) {

                                    $scope.listjabatan_BCA = data.data.d;


                                }, function (error) { });
                                console.log('hhhh', $scope.OPBBCABO.occupation.key);

                                if ($scope.OPBBCABO.occupation.key == 2 || $scope.OPBBCABO.occupation.key == 3 || $scope.OPBBCABO.occupation.key == 18) {
                                    console.log('hh');
                                    $scope.OPBBCABO.positionText = $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerPosition;
                                    $scope.OPBBCABO.businessText = $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNatureOfBusiness;

                                }
                            }



                        }

                        if ($scope.CIFInvestor) {

                            if ($scope.CIFInvestor.Occupation == 1 || $scope.CIFInvestor.Occupation == 2) {

                                $scope.spouseMandatory = true;
                            }
                        }

                        $scope.BenefCountrySelected = $filter('filter')($scope.ListCountry, { CIFCountryNID: Number($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCountry) }, true)[0];

                        if (data.data.d.CIFInvestorBeneficiaryOwnerCity) {

                            $scope.IDCardCitySelectedBO = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.CIFInvestorBeneficiaryOwnerCity }, true)[0];

                            $http({
                                method: 'GET',
                                url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.CIFInvestorBeneficiaryOwnerCity,
                                cache: true,
                            }).then(function (data) {
                                $scope.ListKecamatanBO = data.data.d;
                                if ($scope.ListKecamatanBO)
                                    $scope.ListKelurahanBO = $filter('filter')($scope.ListKecamatanBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan }, true);
                            }, function (error) { });
                                
                        }


                        console.log('IDCardCitySelectedBO ', $scope.IDCardCitySelectedBO)


                        if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity)
                            $scope.CompanyCityBOSelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity }, true)[0];

                        if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource) {

                            $scope.selectedFundSourceBO = [];
                            let temp = $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource.split(',');

                            for (var i = 0; i < temp.length; i++) {

                                $scope.selectedFundSourceBO.push(Number(temp[i]));
                            }
                        }


                        if (data.data.d.CIFInvestorBeneficiaryOwnerBirthDate)
                            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerBirthDate = new Date(data.data.d.CIFInvestorBeneficiaryOwnerBirthDate);


                        if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation == 0)
                            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation = '';
                        if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerDistribution == 0)
                            $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerDistribution = '';

                    }
                }
            })
        });

        //validation popup
        $scope.showModal = false;
        $scope.captchaValid = false;

        $scope.closeModal = function () {
            $scope.showModal = false;
        }

        //window.onCaptchaSuccess = function (response) {
        //    $scope.$apply(function () {
        //        $scope.captchaValid = true;
        //        $scope.captchaResponse = response;
        //    });
        //};
        //end validation popup

        $scope.submit = function (form) {

            //validation popup
            $scope.errorMessages = [];

            angular.forEach(form, function (field, fieldName) {

                if (fieldName.startsWith('$')) return;

                if (field.$error && field.$error.required) {

                    let label = field.$name.toUpperCase();

                    $scope.errorMessages.push(label + ' wajib diisi');
                }
            });

            //if (!$scope.captchaValid) {
            //    $scope.errorMessages.push('Captcha wajib diisi');
            //}

            if ($scope.errorMessages.length > 0) {
                $scope.showModal = true;
                return;
            }
            //validation end

            $scope.prepareData();

            var finished = 0;

            if ($scope.kkbenefFile)
                $scope.CIFInvestor.KKBenefFile = $scope.fileKKBenef;

            //if ($scope.kkbenefPhoto)
            //    $scope.CIFInvestor.KKBenefFile = $scope.kkbenefPhoto.replace("data:image/jpeg;base64,", "").replace("data:image/png;base64,", "");

            $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah data yang diisi sudah sesuai?")
            .then((result) => {
                if (result.value) {
                    $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                    $http({
                        method: 'POST',
                        url: 'service/client.svc/SaveCIF',
                        data:
                            {
                                cifdata: $scope.CIFInvestor
                            },
                    }).then(function (data) {

                        if (data.data.d.result) {
                            swal.close();
                            $window.location.href = "#/cif/data-pendukung";
                        }
                        else {
                            Swal.fire('Failed', data.data.d.response, 'error');
                        }
                    }, function (error) {
                        Swal.fire('Error', 'error - Please check your connection', 'error');
                    });
                }
            });

        }

        $scope.validationinput = function () {

            var errorForm = $scope.myForm.$error.required
            var validation = $scope.myForm.$valid;
            var message = [];
            //console.log('error :', errorForm);

            if (errorForm) {
                for (let i = 0; i < errorForm.length; i++) {
                    //message += errorForm[i].$name + " , ";
                    message.push(errorForm[i].$name);
                }
            }

            //console.log($scope.CIFInvestor.BankStatus);

            //if (!$scope.kkbenefPhoto) {
            //    $scope.validation = false
            //    message.push("kkbenefPhoto");
            //}

            //PROSES VALIDATION
            if (validation == false) {
                console.log("error : " + message);

                var SWALtranslate = $scope.SWALtranslate('validationinput');
                Swal.fire({
                    title: SWALtranslate.title,
                    text: SWALtranslate.message,
                    imageUrl: 'img/collection/wrong.png',
                    imageAlt: 'Preparation',
                    imageHeight: 250,
                    animation: false
                });
            }

        }
    });